import { Loading } from '@/components/shared/Loading';
import { getMonthBounds } from '@/helpers/dateHelper';
import { useMySchedule } from '@/services/employee/schedule/useMySchedule';
import { FunctionComponent, useMemo } from 'react';
import { calculateScheduleSummary } from './scheduleSummary';
import SummaryCard from './SummaryCard';

const SummarySection: FunctionComponent = () => {
  const [start, end] = getMonthBounds(new Date());
  const { schedule, fetching } = useMySchedule(start, end);

  const summary = useMemo(() => calculateScheduleSummary(schedule ?? {}), [schedule]);

  if (fetching) return <Loading />;

  return <SummaryCard summary={summary} />;
};

export default SummarySection;
